export enum GroupTypeEnum {
  FAMILY = 'family',
  COMPANY = 'company',
}
